import React from 'react'
import { DIAGNOSIS_READ, DIAGNOSIS_WRITE } from '../../../../utils/roles'
import RenderOnRole from '../../../../components/RenderOnRole'
import Diagnosis from '../Diagnosis'

const DiagnosisDental = () => {
  return (
    <RenderOnRole
      roles={[DIAGNOSIS_READ, DIAGNOSIS_WRITE]}
      element={<Diagnosis intent='diagnosisDental' />}
    />
  )
}

export default DiagnosisDental
